import React from 'react'

import s from './styles.module.scss'

import LineSeasonPrice from '../line-season-price/LineSeasonPrice'
import { SeasonPriceModeEnum } from '../season-price/SeasonPriceModeEnum'
import {
  ClientPricingItemSeasonPricesOutputDto,
  SeasonEnum,
} from '../../../../../../../../lib/graphql'

const TagPriceSeasonPrices = ({
  seasonPrices,
}: {
  seasonPrices: ClientPricingItemSeasonPricesOutputDto
}) => {
  return (
    <div className={s.seasonPrices}>
      <LineSeasonPrice
        season={SeasonEnum.LOW}
        priceObject={seasonPrices[SeasonEnum.LOW] ?? undefined}
        label='Tarif'
        mode={SeasonPriceModeEnum.TAG_PRICE}
      />
      <LineSeasonPrice
        season={SeasonEnum.MEDIUM}
        priceObject={seasonPrices[SeasonEnum.MEDIUM] ?? undefined}
        label='Tarif'
        mode={SeasonPriceModeEnum.TAG_PRICE}
      />
      <LineSeasonPrice
        season={SeasonEnum.HIGH}
        priceObject={seasonPrices[SeasonEnum.HIGH] ?? undefined}
        label='Tarif'
        mode={SeasonPriceModeEnum.TAG_PRICE}
      />
    </div>
  )
}

export default TagPriceSeasonPrices
